import { sanitizeFilename } from "../sanitizeFilename";
import { flattenConceptQuestionSections } from "../../concept-questions/flattenConceptQuestionSections";

export function conceptQuestionsToPptDocument(result) {
  const questions = flattenConceptQuestionSections(result.sections ?? []);

  const slides = [
    {
      kind: "title",
      title: result.title,
      subtitle: [result.curriculumLabel, result.subtitle].filter(Boolean).join("\n"),
    },
    ...questions.map((question) => ({
      kind: "bullets",
      title: `${String(question.number).padStart(2, "0")}. Question ${question.number}`,
      bullets: [question.prompt],
    })),
  ];

  return {
    filename: sanitizeFilename(result.title, "concept-questions"),
    title: result.title,
    subject: result.curriculumLabel,
    author: "Tema Generate Concept Questions",
    slides,
  };
}
